import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import LeftSidebar from "../components/LeftSidebar";
import RightSidebar from "../components/RightSidebar";
import GiftUsModal from "../components/GiftUsModal";
import MobileLayout from "../mobile/MobileLayout";
import "./AppLayout.css";

const MOBILE_QUERY = "(max-width: 900px)";

const AppLayout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [currentUser, setCurrentUser] = useState(null);
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [isMobileWeb, setIsMobileWeb] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(MOBILE_QUERY).matches : false
  );

  useEffect(() => {
    try {
      const savedUser = JSON.parse(localStorage.getItem("currentUser"));
      if (savedUser) setCurrentUser(savedUser);
    } catch {
      setCurrentUser(null);
    }
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    const updateLayout = (event) => setIsMobileWeb(event.matches);

    setIsMobileWeb(mediaQuery.matches);
    mediaQuery.addEventListener?.("change", updateLayout);

    return () => mediaQuery.removeEventListener?.("change", updateLayout);
  }, []);

  if (isMobileWeb) {
    return <MobileLayout currentUser={currentUser}>{children}</MobileLayout>;
  }

  const thumbnail = currentUser?.thumbnail?.startsWith("http")
    ? currentUser.thumbnail
    : currentUser?.thumbnail
    ? `${process.env.REACT_APP_API_URL}/${currentUser.thumbnail}`
    : "/images/default-thumbnail.jpg";

  return (
    <div className="app-layout">
      {!isHomePage && <Header />}

      <div className="content-container">
        <LeftSidebar
          userThumbnail={thumbnail}
          userName={currentUser?.username || "User"}
        />

        <main className="main-content">{children}</main>

        <RightSidebar
          currentUser={currentUser}
          onOpenGiftModal={() => setShowGiftModal(true)}
        />
      </div>

      <Footer />

      {showGiftModal && (
        <GiftUsModal onClose={() => setShowGiftModal(false)} />
      )}
    </div>
  );
};

export default AppLayout;
